import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=5bc9e98f"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc9e98f')) {
      api.createRecord('5bc9e98f', component.options)
    } else {
      api.reload('5bc9e98f', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=5bc9e98f", function () {
      api.rerender('5bc9e98f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Loader.vue"
export default component.exports